import { render } from "./RedeemVoucherComponent.vue?vue&type=template&id=4626c1ee&ts=true"
import script from "./RedeemVoucherComponent.vue?vue&type=script&lang=ts"
export * from "./RedeemVoucherComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__